import { useSelector } from "react-redux";
import { isStaff, isStudent, isAdmin } from "./role";

const useAuth = () => {
  const {
    role = [],
    id,
    firstname,
    lastname,
    personalId,
    email,
    classNo,
    roomNo,
    schoolId,
    schoolName,
    nickname,
    username,
  } = useSelector((s) => s.auth.userInfo);
  return {
    isStudent: isStudent(role),
    isStaff: isStaff(role),
    isAdmin: isAdmin(role),
    id,
    firstname,
    lastname,
    personalId,
    email,
    classNo,
    roomNo,
    schoolId,
    schoolName,
    nickname,
    username,
  };
};

export default useAuth;
